import { atom } from 'nanostores';
import { useStore } from '@nanostores/react';
import type { ServicesApiGetEnvHealthQueryParams } from '@/services/api/services-api';

type SimulateValue = NonNullable<ServicesApiGetEnvHealthQueryParams['simulate']>;

const $simulate = atom<SimulateValue | undefined>(undefined);

export function useWorkspaceHealthSimulation() {
  const simulate = useStore($simulate);
  const handleSetSimulate = (value: SimulateValue | undefined) => $simulate.set(value);

  return { simulate, handleSetSimulate };
}
